import RawTour from "@/RawTour";
import {Tour} from "@/Tour";

export function SletatRuDriver(tours: RawTour[]): Tour[]{
    const out: Tour[] = [];

    for (const tour of tours){

        // _228_300_1.jpg

        let image = tour.hotel.images[0][ Object.keys(tour.hotel.images[0])[0] ];
        image = image.replace(".jpg","_228_300_1.jpg");

        out.push({
            name: tour.hotel.name,
            desc: tour.hotel.desc,
            construction_year: tour.hotel.features.construction_year,
            renovation_year: tour.hotel.features.renovation_year,
            airport_distance: tour.hotel.features.airport_distance,
            beach_distance: tour.hotel.features.beach_distance,
            beach_size: tour.hotel.features.beach_size,
            beach_type: tour.hotel.features.beach_type,
            beach_surface: tour.hotel.features.beach_surface,
            area: tour.hotel.features.area,
            wi_fi: tour.hotel.features.wi_fi,
            ski_lift_distance: tour.hotel.features.ski_lift_distance,
            ski_in: tour.hotel.features.ski_in,
            ski_out: tour.hotel.features.ski_out,
            fitness: tour.hotel.features.fitness,
            aquapark: tour.hotel.features.aquapark,
            nanny: tour.hotel.features.nanny,
            kids_menu: tour.hotel.features.kids_menu,
            kids_club: tour.hotel.features.kids_club,
            kids_pool: tour.hotel.features.kids_pool,
            pool: tour.hotel.features.pool,
            heated_pool: tour.hotel.features.heated_pool,
            aircon: tour.hotel.features.aircon,
            parking: tour.hotel.features.parking,
            thermal_fun: tour.hotel.features.thermal_fun,
            bar: tour.hotel.features.bar,
            indoor_pool: tour.hotel.features.indoor_pool,
            no_single_men: tour.hotel.features.no_single_men,
            min_age: tour.hotel.features.min_age,
            line: tour.hotel.features.line,
            image: {
                preview: image,
                full_size: image
            },
            extras: [],
            link: tour.tourPageUrl,
            min_price: tour.infoPrice,
            rating: tour.hotel.rating,
            stars: tour.hotel.stars,
            marketplace: "Sletat"
        });
    }

    return out;
}